var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station-invoice" },
    [
      _vm.formInfo.types !== 3
        ? _c(
            "div",
            { staticClass: "btn-box" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.handleBuild(
                        0,
                        _vm.buildData.invoicing_switch,
                        "invoicing_switch"
                      )
                    },
                  },
                },
                [_vm._v("\n      申请开票\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "amount mt10" }, [
        _c("div", [
          _c("span", { staticClass: "amount-label" }, [
            _vm._v("累计开票金额(元)："),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "amount-val" }, [
            _vm._v(_vm._s(_vm.cumulative_invoiced_price)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "amount-label ml36" }, [
            _vm._v("审核中开票金额(元)："),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "amount-val" }, [
            _vm._v(_vm._s(_vm.audit_invoiced_price)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "amount-label ml36" }, [
            _vm._v("累计收款金额(元)："),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "amount-val" }, [
            _vm._v(" " + _vm._s(_vm.cumulative_payment_price)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", height: "100%" },
          attrs: { data: _vm.tableData },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "created_at",
              label: "申请时间",
              sortable: "",
              "min-width": "150",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "title", label: "发票抬头", "min-width": "150" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "amount",
              label: _vm.$t("customer.invoicingpay"),
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class:
                          scope.row.price == scope.row.amount ? "" : "active",
                      },
                      [_vm._v(_vm._s(scope.row.amount))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "price", label: "付款金额(元)", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class:
                          scope.row.price == scope.row.amount ? "" : "active",
                      },
                      [_vm._v(_vm._s(scope.row.price))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "发票审核状态",
              "min-width": "110",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            scope.row.status == -1
                              ? "danger"
                              : scope.row.status == -1
                              ? "warning"
                              : "info",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getInvoiceStatus(scope.row.status)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "address",
              "min-width": "190",
              label: _vm.$t("public.operation"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleCheck(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("public.check")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.setRemarks(scope.row)
                          },
                        },
                      },
                      [_vm._v("备注")]
                    ),
                    _vm._v(" "),
                    scope.row.status === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.invoiceWithdrawal(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          发票撤回\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 5
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleBuild(
                                  scope.row,
                                  _vm.buildData.void_invoice_switch,
                                  "void_invoice_switch"
                                )
                              },
                            },
                          },
                          [_vm._v("\n          申请作废\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.status === 4
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.invoiceWithdrawal(scope.row, 1)
                              },
                            },
                          },
                          [_vm._v("作废撤回")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 2 } }),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 22 } }, [
            _c(
              "div",
              { staticClass: "block mt10 text-right" },
              [
                _c("el-pagination", {
                  attrs: {
                    "page-size": _vm.where.limit,
                    "current-page": _vm.where.page,
                    layout: "total, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: { "current-change": _vm.pageChange },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "addBox",
          attrs: {
            title: _vm.title,
            top: "25vh",
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "540px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              staticClass: "from",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.reason + "：",
                    "label-width": "90px",
                    prop: "remarks",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", placeholder: "请填写原因" },
                    model: {
                      value: _vm.form.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: { click: _vm.cancelFn },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.submitFn },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("invoice-apply", {
        ref: "invoiceApply",
        attrs: {
          contractInvoice: _vm.contractInvoice,
          "form-data": _vm.formBoxConfig,
        },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("mark-dialog", {
        ref: "markDialog",
        attrs: { config: _vm.configMark },
        on: {
          isMark: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("invoice-details", {
        ref: "invoiceDetailsView",
        attrs: { "form-data": _vm.invoiceData },
      }),
      _vm._v(" "),
      _c("invoice-view", {
        ref: "invoiceView",
        attrs: { "form-data": _vm.invoiceData },
      }),
      _vm._v(" "),
      _c("mergeInvoice", {
        ref: "mergeInvoice",
        attrs: {
          isApproval: _vm.is_approval,
          contractInvoice: _vm.contractInvoice,
          "form-data": _vm.formBoxConfig,
          parameterData: _vm.parameterData,
        },
        on: { isOk: _vm.isOk, getTableData: _vm.getTableData },
      }),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { parameterData: _vm.parameterData },
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }